module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.itens.length) ? _c('ul', {
    staticClass: "hotsite-lista lista"
  }, _vm._l((_vm.itens), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "item",
      class: _vm.icone
    }, [(_vm.rota) ? _c('router-link', {
      attrs: {
        "to": {
          name: _vm.rota,
          params: {
            id: item.slug
          }
        }
      },
      domProps: {
        "innerHTML": _vm._s(item.titulo)
      }
    }) : (item.url) ? _c('a', {
      attrs: {
        "href": item.url
      },
      domProps: {
        "innerHTML": _vm._s(item.titulo)
      }
    }) : _vm._e()], 1)
  }), 0) : _c('div', {
    staticClass: "loading-container lista-loading"
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Carregando...")]), _vm._m(0), _vm._m(1), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "slot"
  }, [_c('div', {
    staticClass: "icone animated"
  })]), _c('div', {
    staticClass: "slot"
  }, [_c('div', {
    staticClass: "texto animated"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "slot"
  }, [_c('div', {
    staticClass: "icone animated"
  })]), _c('div', {
    staticClass: "slot"
  }, [_c('div', {
    staticClass: "texto animated"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "slot"
  }, [_c('div', {
    staticClass: "icone animated"
  })]), _c('div', {
    staticClass: "slot"
  }, [_c('div', {
    staticClass: "texto animated"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b76a077","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/HotsiteLista.vue
// module id = 499
// module chunks = 0